import { zeroAddress } from 'viem'
import type { ChainConfig } from '../types'

export const HYPERLIQUID = {
  name: 'hyperliquid',
  chainId: 999,
  averageBlockTimeSeconds: 1,
  explorerUrl: 'https://hyperevmscan.io/',
  nativeAsset: {
    assetAddress: zeroAddress,
    name: 'Hyperliquid',
    symbol: 'HYPE',
    decimals: 18,
  },
  slip44: 60,
  wrappedNativeAsset: '0x5555555555555555555555555555555555555555',
  blockscoutApiUrl: undefined,
  etherscanSupported: true,
  publicRpcUrls: ['https://rpc.hyperlend.finance'],
  getPrivateRpcUrls: () => {
    const hyperliquid: string[] = []
    hyperliquid.push('https://rpc.hyperlend.finance')
    process.env.ROUTEME_API_KEY && hyperliquid.push(`https://lb.routeme.sh/rpc/999/${process.env.ROUTEME_API_KEY}`)
    process.env.ALCHEMY_API_KEY &&
      hyperliquid.push(`https://hyperliquid-mainnet.g.alchemy.com/v2/${process.env.ALCHEMY_API_KEY}`)
    return hyperliquid
  },
} as const satisfies ChainConfig
